import { Component, ViewChild } from '@angular/core';
import {
  breadcrumb,
  link,
  stat,
} from 'src/app/admin/layout/header/header.component';
import { QuestionBase } from 'src/app/misc/component/dynamic-form/question-base';
import { DropdownQuestion } from 'src/app/misc/component/dynamic-form/question-dropdown';
import { TextboxQuestion } from 'src/app/misc/component/dynamic-form/question-textbox';
import icons from '../../../../misc/data/icons.json';
import { SelectItem } from 'primeng/api';
import { DataService } from 'src/app/services/data.service';
import { DynamicFormComponent } from 'src/app/misc/component/dynamic-form/dynamic-form.component';
import { Message } from 'primeng/api';
import {
  ConfirmationService,
  MessageService,
  ConfirmEventType,
} from 'primeng/api';
import { NumberQuestion } from 'src/app/misc/component/dynamic-form/question-number';
import { PermissionHandlerService } from 'src/app/services/permission-handler.service';

import { TranslatorPipe } from 'src/app/services/translator.pipe';
import { IconBoxQuestion } from 'src/app/misc/component/dynamic-form/question-iconbox';

@Component({
  selector: 'app-data-fields',
  templateUrl: './data-fields.component.html',
  styleUrls: ['./data-fields.component.scss'],
  providers: [ConfirmationService, MessageService],
})
export class DataFieldsComponent {
  skelition = true;

  @ViewChild(DynamicFormComponent) DynamicFormComponent:
    | DynamicFormComponent
    | any;
 
  messages: Message[] = [];
  translator: TranslatorPipe = new TranslatorPipe()

  header = this.translate('Data classification');
  links: link[] = [
    {
      name: this.translate('Back'),
      icon: 'pi pi-arrow-left',
      link: '/admin/data',
      visible: this.permissionService.hasPermission('DATA', 'r')
    },
    {
      name: this.translate('Types of classifications'),
      icon: 'pi pi-file-edit',
      link: '/admin/data/fields/types',
      visible: this.linkPermissions('DATA_FIELD_TYPE'),
    },
    {
      name: this.translate('data types'),
      icon: 'pi pi-list',
      link: '/admin/data/types',
      visible: this.linkPermissions('DATA_TYPE')
    },
    {
      name: this.translate('data templates'),
      icon: 'pi pi-plus',
      link: '/admin/data/templates',
      visible: this.linkPermissions('DATA_TEMPLATE')
    },
  ];
  breadcrumbs: breadcrumb[] = [
    { name: this.translate('data'), link: '/admin/data' },
    { name: this.translate('Add data'), link: '/admin/data/add' },
    { name: this.translate('Organize data templates'), link: '/admin/data/templates' },
    { name: this.translate('Organizing classifications'), link: '/admin/data/fields' },
  ];

  stats: stat[] = [];

  fieldData: any[] = [];
  fieldType: any[] = [];

  data: any[] = [];
  iconOptions: SelectItem[] = [];
  questions: QuestionBase<string>[] = [];

  // Update data
  updateModal = false;
  updateData: any;
  updateQuestions: any;

  constructor(
    private dataService: DataService,
    private confirmationService: ConfirmationService,
    public permissionService: PermissionHandlerService
  ) { }

  linkPermissions(flag: string) {
    return this.permissionService.hasAnyPermission([{ unit: flag, flag: 'c' }, { unit: flag, flag: 'u' }, { unit: flag, flag: 'd' }]);
  }

  ngOnInit() {
    icons.forEach((icon: { i: string; n: string }) => {
      this.iconOptions.push({ label: icon.n, icon: icon.i, value: icon.i });
    });

    this.iconOptions = this.iconOptions.sort((a, b) => {
      if (a.label && b.label) {
        if (a.label < b.label) {
          return -1;
        }
        if (a.label > b.label) {
          return 1;
        }
        return 0;
      } else {
        return 0;
      }
    });

    this.getFieldData();
    this.fetchDataType().then(() => {
      this.makequestion();
    });
  }

  translate(key: string) {
    let translator: TranslatorPipe = new TranslatorPipe();
    return translator.transform(key);
  }

  private async fetchDataType(): Promise<void> {
    let res = await this.dataService.postData('field-type/get', {
      active: true,
    });
    console.log(res.data);
    if (res.error) {
      return;
    }
    this.fieldType = res.data.map((item: any) => {
      return {
        _id: item._id,
        label: item.arabic,
        icon: `pi pi-${item.icon}`,
        value: item._id,
      };
    });
  }

  getFieldData = async () => {
    try {
      let res = await this.dataService.postData('data-fields/get/', {});
      if (res.error) {
        this.messages = [
          { severity: 'error', summary: this.translate('error'), detail: res.msg },
        ];
        return;
      }
      this.fieldData = res.data;
      this.fieldData.forEach((item: any) => {
        this.data.push({
          '#': { n: item._id, i: 'pi pi-angle-left' },
          'اسم التصنيف': { n: item.name, i: item.icon },
          'نوع التصنيف': { n: item?.type?.arabic },
          'الأولوية': { n: item?.priority },
          الحالة: {
            n: item.active,
            i: item.active ? 'pi pi-check-circle' : 'pi pi-check-circle',
          },
          Action: [
            {
              n: 'Delete',
              i: 'pi pi-times',
              s: 'p-button-rounded p-button-danger p-button-text p-button-raised',
            },
            {
              n: 'Update',
              i: 'pi pi-file-edit',
              s: 'p-button-rounded p-button-warning p-button-text p-button-raised',
            },
          ],
        });
      });
      this.updateTypeCounts();
      this.skelition = false;
      console.log('data ou catagory => ', this.fieldData, this.data);
    } catch (error) {
      console.log(error);
    }
  };

  makequestion() {
    this.questions = [
      new TextboxQuestion({
        key: 'name',
        label: this.translate('Category Name'),
        required: true,
        order: 1,
        icon: 'pi pi-file',
        className: 'col-md-12 col-sm-12 col-12',
      }),

      new DropdownQuestion({
        key: 'type',
        label: this.translate('Category Type'),
        required: true,
        options: this.fieldType,
        filter: true,
        order: 2,
        className: 'col-md-12 col-sm-12 col-12',
      }),

      new NumberQuestion({
        key: 'priority',
        label: this.translate('Priority'),
        required: true,
        order: 4,
        icon: 'pi pi-sort-numeric-down',
        className: 'col-md-12 col-sm-12 col-12',
      }),

      new IconBoxQuestion({
        key: 'icon',
        label: this.translate('Category Icons'),
        required: true,

        filter: true,
        order: 4,
        className: 'col-md-12 col-sm-12 col-12',
      }),

      new DropdownQuestion({
        key: 'active',
        label: this.translate('Category Status'),
        options: [
          { label: this.translate('active'), icon: 'pi pi-check-circle', value: true },
          { label: this.translate('Inactive'), icon: 'pi pi-times-circle', value: false },
        ],
        order: 5,
        className: 'col-md-12 col-sm-12 col-12',
        value: true,
        visibility: 'false',
      }),
    ];
  }

  receiveData = async ($event: any) => {
    try {
      let data = $event;

      let res = await this.dataService.postData('data-fields/', data);
      if (res.error) {
        this.messages = [
          { severity: 'error', summary: this.translate('error'), detail: res.msg },
        ];
        return;
      }
      this.messages = [
        { severity: 'success', summary: this.translate('success'), detail: res.msg },
      ];
      this.DynamicFormComponent.resetForm();
      data.type = this.fieldType.find((e) => e._id == data.type);
      data.type.name = data.type.label;
      data.type.arabic = data.type.label;
      let updatedData = res.data;
      updatedData.type = this.fieldType.find((e) => e._id == updatedData.type);
      updatedData.type.name = updatedData.type.label;
      updatedData.type.arabic = updatedData.type.label;
      this.fieldData.push(updatedData);
      this.data.unshift({
        '#': { n: res.data._id, i: 'pi pi-angle-left' },
        'اسم التصنيف': { n: data.name, i: data.icon },
        'نوع التصنيف': { n: data.type.arabic },
        priority: { n: data.priority },
        الحالة: {
          n: data.active,
          i: data.active ? 'pi pi-check-circle' : 'pi pi-check-circle',
        },
        Action: [
          {
            n: 'Delete',
            i: 'pi pi-times',
            s: 'p-button-rounded p-button-danger p-button-text p-button-raised',
          },
          {
            n: 'Update',
            i: 'pi pi-file-edit',
            s: 'p-button-rounded p-button-warning p-button-text p-button-raised',
          },
        ],
      });
      this.updateTypeCounts();
    } catch (error) {
      console.log(error);
    }
  };

  UpdateData = async ($event: any) => {
    try {
      let data: any = $event;
      data._id = this.updateData._id;
      let res = await this.dataService.postData(
        'data-fields/',
        data,
        'PUT',
        false
      );
      if (res.error) {
        this.messages = [
          { severity: 'error', summary: this.translate('error'), detail: res.msg },
        ];
        return;
      }
      this.messages = [
        { severity: 'success', summary: this.translate('success'), detail: res.msg },
      ];
      this.updateModal = false;
      this.updateData = undefined;
      let type = this.fieldType.find((e) => e._id == data.type);
      data.type = {
        _id: type._id,
        name: type.label,
        arabic: type.label,
        active: type.active,
        label: type.label,
      };
      // updating in table
      const myObject = this.data.find((item) => item['#'].n === data._id);
      if (myObject) {
        (myObject['اسم التصنيف'].n = data.name),
          (myObject['اسم التصنيف'].i = data.icon);
        myObject['الحالة'].n = data.active;
        myObject['priority'].n = data.priority;
        myObject['الحالة'].i = data.active
          ? 'pi pi-check-circle'
          : 'pi pi-check-circle';
        myObject.Type.n = data.type.name;
      }

      this.data.map((e, i) => {
        if (e['#'].n === data._id) {
          this.data[i] = myObject;
          return;
        }
      });

      this.fieldData.map((e, i) => {
        if (e._id === data._id) {
          this.fieldData[i] = data;
          return;
        }
      });
      console.log(this.fieldData);
      this.updateTypeCounts();
    } catch (error) {
      console.log(error);
    }
  };

  actionCall($event: any) {
    console.log('==> Action Call recieved=', $event);
    switch ($event.action) {
      case 'Delete':
        this.confirm({
          message: this.translate('Are you sure you want to do this?'),
          header: this.translate('Confirmation message'),
          icon: 'pi pi-exclamation-triangle',
          action: () => this.deleteCatagory($event.id),
        });
        break;
      case 'Update':
        this.updateData = this.fieldData.find((item) => item._id == $event.id);
        this.updateQuestions = [
          new TextboxQuestion({
            key: 'name',
            label: 'اسم التصنيف',
            required: true,
            order: 1,
            icon: 'pi pi-file',
            value: this.updateData.name,
            className: 'col-12',
          }),

          new DropdownQuestion({
            key: 'type',
            label: 'نوع التصنيف',
            required: true,
            options: this.fieldType,
            filter: true,
            order: 2,
            value: this.updateData.type._id,
            className: 'col-12',
          }),

          new NumberQuestion({
            key: 'priority',
            label: 'priority',
            required: true,
            order: 3,
            icon: 'pi pi-sort-numeric-down',
            value: this.updateData.priority,
            className: 'col-12',
          }),

          new IconBoxQuestion({
            key: 'icon',
            label: 'الايقونات',
            required: true,

            filter: true,
            order: 4,
            value: this.updateData?.icon,
            className: 'col-12',
          }),

          new DropdownQuestion({
            key: 'active',
            label: 'الحالة',
            required: true,
            value: this.updateData?.active,
            options: [
              { label: this.translate('active'), icon: 'pi pi-check-circle', value: true },
              { label: this.translate('Inactive'), icon: 'pi pi-times-circle', value: false },
            ],
            order: 5,
            className: 'col-12',
          }),
        ];
        console.log('Update Data ==>', this.fieldData, this.updateData);
        console.log(this.updateData.type._id);
        this.updateModal = true;
        break;
      default:
        console.log('Unknown color');
        break;
    }
  }

  deleteCatagory = async (id: string) => {
    try {
      let res = await this.dataService.deleteData(`data-fields/${id}`);
      if (res.error) {
        this.messages = [
          { severity: 'error', summary: this.translate('error'), detail: res.msg },
        ];
        return;
      }
      this.messages = [
        { severity: 'success', summary: this.translate('success'), detail: res.msg },
      ];
      this.data = this.data.filter((item) => item['#'].n !== id);
      this.fieldData = this.fieldData.filter((item) => item._id !== id);
      this.updateTypeCounts();
    } catch (error) {
      console.log(error);
    }
  };

  confirm(parems: any) {
    this.confirmationService.confirm({
      message: parems.message,
      header: parems.header,
      icon: parems.icon,
      acceptLabel: 'نعم',
      rejectLabel: 'لا',
      accept: () => {
        parems.action();
        return true;
      },
      reject: (type: any) => {
        switch (type) {
          case ConfirmEventType.REJECT:
            return false;
          case ConfirmEventType.CANCEL:
            return false;
          default:
            return false;
        }
      },
    });
  }

  private updateTypeCounts(): void {
    let activeCount = this.fieldData.filter((e) => e.active === true).length;
    let inactiveCount = this.fieldData.length - activeCount;
    this.stats = [
      { name: this.translate('active'), number: activeCount, icon: 'pi pi-check-circle' },
      { name: this.translate('Inactive'), number: inactiveCount, icon: 'pi pi-times-circle' },
    ];
  }
}
